// アンケート（四択/自由記述）送信

function csrfToken() {
  const token = document.querySelector('meta[name="csrf-token"]')?.content;
  return token || '';
}

function showError($section, message) {
  const $error = $section.find('.js-survey-error');
  if (!$error.length) return;
  $error.text(message);
  $error.show();
}

async function postJson(url, payload) {
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken(),
    },
    credentials: 'same-origin',
    body: JSON.stringify(payload),
  });

  const json = await res.json().catch(() => ({}));
  return { ok: res.ok, status: res.status, json };
}

function replaceWithThanks($section, message) {
  const $p = $('<p>').addClass('survey-thanks').text(message);
  $section.empty().append($p);
}

function showTemporaryThanks($section, message) {
  const $thanks = $('<p>').addClass('survey-thanks js-survey-temporary-thanks').text(message);
  $section.find('.js-survey-free-text-form').before($thanks);
  setTimeout(function () {
    $thanks.fadeOut(500, function () { $thanks.remove(); });
  }, 10000);
}

function markChoiceAnswered($section, $btn) {
  $section.find('.js-survey-choice').prop('disabled', true);
  $section.find('.js-survey-choice').removeClass('is-selected');
  $btn.addClass('is-selected');
  $section.find('.js-survey-answered-note').show();

  const selectedText = $btn.text()?.toString()?.trim() || '';
  const $summary = $section.find('.js-survey-answer-summary');
  if ($summary.length) {
    // button text をHTMLとして注入しない（XSS対策）
    $summary.empty().append($('<strong>').text(selectedText));
    $summary.show();
  }

  $section.find('.survey-choices').hide();
}

function textLength(text) {
  return Array.from(text || '').length;
}

function updateFreeTextCounter($section) {
  const $input = $section.find('input[name="free_text"]');
  const $counter = $section.find('.js-survey-free-text-counter');
  if (!$input.length || !$counter.length) return;

  const max = parseInt($input.attr('maxlength') || '100', 10);
  const len = textLength($input.val()?.toString() || '');
  $counter.text(`${len}/${max}`);
}

function randomThanksMessage($section) {
  const messages = $section.data('thanks-messages');
  if (!Array.isArray(messages) || messages.length === 0) return '';
  return messages[Math.floor(Math.random() * messages.length)];
}

$(document).on('turbolinks:load', function () {
  $('.js-survey-section').each(function () {
    updateFreeTextCounter($(this));
  });

  $(document).off('click.surveyChoice').on('click.surveyChoice', '.js-survey-choice', async function () {
    const $btn = $(this);
    const $section = $btn.closest('.js-survey-section');

    const surveyId = $btn.data('survey-id');
    const surveyOptionId = $btn.data('survey-option-id');

    if (!surveyId || !surveyOptionId) return;

    $section.find('.js-survey-error').hide();
    $section.find('.js-survey-choice').prop('disabled', true);

    const { ok, json } = await postJson('/api/survey_responses', {
      survey_id: surveyId,
      survey_option_id: surveyOptionId,
    });

    if (ok && json.ok) {
      markChoiceAnswered($section, $btn);
      return;
    }

    $section.find('.js-survey-choice').prop('disabled', false);
    showError($section, json.error || $section.data('error-submit'));
  });

  $(document).off('input.surveyFreeText').on('input.surveyFreeText', 'input[name="free_text"]', function () {
    updateFreeTextCounter($(this).closest('.js-survey-section'));
  });

  $(document).off('submit.surveyFreeText').on('submit.surveyFreeText', '.js-survey-free-text-form', async function (e) {
    e.preventDefault();

    const $form = $(this);
    const $section = $form.closest('.js-survey-section');

    const freeText = ($form.find('input[name="free_text"]').val()?.toString() || '').trim();

    $section.find('.js-survey-error').hide();
    $section.find('.js-survey-temporary-thanks').remove();
    $form.find('button[type="submit"]').prop('disabled', true);
    updateFreeTextCounter($section);

    if (freeText.length === 0) {
      $form.find('button[type="submit"]').prop('disabled', false);
      showError($section, $section.data('error-empty'));
      return;
    }

    const { ok, json } = await postJson('/api/survey_responses', {
      free_text: freeText,
    });

    if (ok && json.ok) {
      const thanksMessage = randomThanksMessage($section);
      const remaining = json.remaining;

      if (remaining != null && remaining > 0) {
        // まだ送信できる: フォームリセット＋残り回数更新＋一時thanksメッセージ
        $form.find('input[name="free_text"]').val('');
        updateFreeTextCounter($section);
        showTemporaryThanks($section, thanksMessage);
        $form.find('button[type="submit"]').prop('disabled', false);
      } else {
        // 上限到達: フォームを非表示にしてthanksメッセージ
        replaceWithThanks($section, thanksMessage);
      }
      return;
    }

    $form.find('button[type="submit"]').prop('disabled', false);
    showError($section, json.error || $section.data('error-submit'));
  });
});
